import { ApiUrl } from './common/Config';
import { get } from './common/Helper';

const baseUrl = ApiUrl + 'role/';

export const getAllRoles = async(token) => {
    let url = baseUrl + 'all';
    return await get(url, token);
};